import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { StudentsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface IUseStudentGetProps {
  id: number;
  enabled?: boolean;
}

export const useStudentGet = ({ id, enabled = true }: IUseStudentGetProps) => {
  const accessToken = useAccessToken();

  const { data, isSuccess, isError, isPending, isFetching, refetch } = useQuery({
    queryKey: [QueryKeys.Students, id],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(StudentsApi, accessToken);
      return service.getStudentById({ id });
    },
    enabled: enabled && !!accessToken,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isSuccess,
    isError,
    isPending,
    isFetching,
    refetch,
  };
};
